__turbopack_context__.v({
  "className": "SQWfhG_className",
  "variable": "SQWfhG_variable",
});
